import React from 'react'

import {
  array,
  bool,
  func,
  object,
  string,
} from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import AdditionalItems from './Components/AdditionalItems/AdditionalItems'
import EmptyCart from './Components/EmptyCart/EmptyCart'
import FullCart from './Components/FullCart/FullCart'

function CartWidget({
  items,
  meta,
  included = EMPTY_ARRAY,
  onLoadNextPage,
  isLastPageLoaded,
  locale,
  trackCartRemoveGA4,
  shouldShowCartProgress = false,
  showCartAds = false,
  isCurrentUser = false,
  onCloseCart = null,
}) {
  const haveItems = meta.size > 0
  const showAdditionalItems = showCartAds && isCurrentUser
  const isCartBelowThreshold = shouldShowCartProgress
    && meta.saleThreshold && meta.totalPrice && meta.saleThreshold > meta.totalPrice
  const isCartAboveThreshold = shouldShowCartProgress
    && meta.saleThreshold && meta.totalPrice && meta.saleThreshold <= meta.totalPrice

  return (
    <span>
      {haveItems ? (
        <FullCart
          items={items}
          meta={meta}
          included={included}
          onLoadNextPage={onLoadNextPage}
          isLastPageLoaded={isLastPageLoaded}
          locale={locale}
          trackCartRemoveGA4={trackCartRemoveGA4}
          isCartBelowThreshold={isCartBelowThreshold}
          isCartAboveThreshold={isCartAboveThreshold}
          shouldShowCartProgress={shouldShowCartProgress}
          onCloseCart={onCloseCart}
        />
      ) : (
        <EmptyCart locale={locale} />
      )}
      {showAdditionalItems && (
        <AdditionalItems
          isCartBelowThreshold={isCartBelowThreshold}
          isCartAboveThreshold={isCartAboveThreshold}
          shouldShowCartProgress={shouldShowCartProgress}
          cartItems={items}
          locale={locale}
        />
      )}
    </span>
  )
}

CartWidget.propTypes = {
  items: array.isRequired,
  meta: object.isRequired,
  included: array,
  onLoadNextPage: func.isRequired,
  isLastPageLoaded: bool.isRequired,
  locale: string.isRequired,
  trackCartRemoveGA4: func.isRequired,
  shouldShowCartProgress: bool,
  showCartAds: bool,
  isCurrentUser: bool,
  onCloseCart: func,
}

export default CartWidget
